import { render } from "./CommonHandlingPanel.vue?vue&type=template&id=71e6ca3a"
import script from "./CommonHandlingPanel.vue?vue&type=script&lang=js"
export * from "./CommonHandlingPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__